import React from "react";
import { Link } from "react-router-dom";

interface ProductItem {
  id: number | string;
  title: string;
  slug: string;
  price: number;
  delPrice: number;
  proImg: string;
}

interface ProductProps {
  products: ProductItem[];
  addToCartProduct: (product: ProductItem) => void;
  addToWishListProduct: (product: ProductItem) => void;
  pClass?: string;
}

const Product: React.FC<ProductProps> = ({
  products,
  addToCartProduct,
  addToWishListProduct,
  pClass = "",
}) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className={`wpo-product-section section-padding ${pClass}`}>
      <div className="container">
        <div className="wpo-section-title">
          <h2 className="poort-text poort-in-right">Special Products For You</h2>
          <p>
            From intimate gatherings to grand luxury weddings, we bring together
            creativity, organization, and passion to design every detail with
            precision.
          </p>
        </div>

        <div className="wpo-product-wrap">
          <div className="row">
            {products.length > 0 &&
              products.slice(0, 4).map((product, index) => (
                <div
                  className="col col-lg-3 col-md-6 col-sm-6 col-12"
                  key={index}
                >
                  <div className="wpo-product-item">
                    <div className="wpo-product-img">
                      <img src={product.proImg} alt={product.title} />
                      <ul>
                        <li>
                          <button
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                            title="Add to Wishlist"
                            onClick={() => addToWishListProduct(product)}
                          >
                            <i className="fi flaticon-heart"></i>
                          </button>
                        </li>
                        <li>
                          <button
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                            title="Add to Cart"
                            onClick={() => addToCartProduct(product)}
                          >
                            Add To Cart
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div className="wpo-product-text">
                      <h3>
                        <Link
                          onClick={ClickHandler}
                          to={`/product-single/${product.slug}`}
                        >
                          {product.title}
                        </Link>
                      </h3>
                      <ul>
                        <li>${product.delPrice}</li>
                        <li>${product.price}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;
